import { useState, useEffect } from "react";
import { getData } from "adminApi/apiClient";

export const useLocationCascading = (values) => {
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingBlocks, setLoadingBlocks] = useState(false);

  const isIndia =
    values?.country &&
    (values.country.toLowerCase() === "india" ||
      values.country.toLowerCase() === "in");

  // Fetch States when Country is India
  useEffect(() => {
    if (isIndia) {
      setLoadingStates(true);
      getData("/location/states")
        .then((res) => {
          if (res?.data) {
            setStates(res.data);
          }
        })
        .catch((err) => console.error("Error fetching states:", err))
        .finally(() => setLoadingStates(false));
    } else {
      setStates([]);
      setDistricts([]);
      setBlocks([]);
    }
  }, [isIndia]);

  // Fetch Districts when State is selected
  useEffect(() => {
    if (isIndia && values?.state) {
      const selectedStateObj = states.find(
        (s) => s.state_code === values.state || s.state_name === values.state,
      );
      const stateCode = selectedStateObj
        ? selectedStateObj.state_code
        : values.state;

      if (stateCode) {
        setLoadingDistricts(true);
        getData(`/location/districts/${stateCode}`)
          .then((res) => {
            if (res?.data) {
              setDistricts(res.data);
            }
          })
          .catch((err) => console.error("Error fetching districts:", err))
          .finally(() => setLoadingDistricts(false));
      }
    } else {
      setDistricts([]);
      setBlocks([]);
    }
  }, [isIndia, values?.state, states]);

  // Fetch Blocks when District (city) is selected
  useEffect(() => {
    if (isIndia && values?.city) {
      const selectedDistrictObj = districts.find(
        (d) =>
          d.district_code === values.city || d.district_name === values.city,
      );
      const districtCode = selectedDistrictObj
        ? selectedDistrictObj.district_code
        : values.city;

      if (districtCode) {
        setLoadingBlocks(true);
        getData(`/location/blocks/${districtCode}`)
          .then((res) => {
            if (res?.data) {
              setBlocks(res.data);
            }
          })
          .catch((err) => console.error("Error fetching blocks:", err))
          .finally(() => setLoadingBlocks(false));
      }
    } else {
      setBlocks([]);
    }
  }, [isIndia, values?.city, districts]);

  return {
    isIndia,
    states,
    districts,
    blocks,
    loadingStates,
    loadingDistricts,
    loadingBlocks,
  };
};
